import { Box, Flex, Grid, GridItem, Text, useTheme } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

import { useAppNav } from '@/hooks/useAppNav.hook';
import { useSettings } from '@/hooks/useSettings';

import { BackButton } from '../BackButton';

const Navigation = () => {
  const theme = useTheme();
  const { mobileNav } = useAppNav();
  return (
    <Grid
      color='white'
      gap='10px'
      gridTemplateRows={`repeat(${mobileNav.length}, 1fr)`}
    >
      {mobileNav.map(({ Icon, ...item }) => (
        <Box
          as={NavLink}
          color={item?.selected ? theme.colors.OlybetPrimaryRed : 'white'}
          key={item.linkData.to as string}
          {...item?.linkData}
        >
          <Flex
            align='center'
            direction='column'
            justify='center'
            padding='10px'
          >
            {!!Icon && (
              <Icon
                {...{
                  fill: item?.selected
                    ? theme.colors.OlybetPrimaryRed
                    : 'white',
                }}
              ></Icon>
            )}
            <Text fontSize='12px' mt='5px' textAlign='center'>
              {item?.label}
            </Text>
          </Flex>
        </Box>
      ))}
    </Grid>
  );
};

export const DesktopSideNavbar = () => {
  const theme = useTheme();
  const { isDesktop } = useSettings();

  return isDesktop ? (
    <Grid
      bgColor={theme.colors.OlybetGrey07}
      color='white'
      gridTemplateRows='1fr 3fr 1fr'
      h='100vh'
      left={0}
      pos='fixed'
      top={0}
      w='112px'
    >
      <GridItem marginTop='20px'>
        <BackButton />
      </GridItem>

      <Flex align='center' justify='center'>
        <Navigation />
      </Flex>

      <GridItem></GridItem>
    </Grid>
  ) : null;
};
